const SearchView = Barba.BaseView.extend({
    namespace: 'search',

    onEnter() {
        new MainMenu(this.container);
        new InViewAnimation();
        new SearchModal(this.container);

        setIframeAspectRatios(this.container);

        console.log('Hi search');
    }
});

SearchView.init();